import { headerStyles as customHeaderStyles } from "@insite/content-library/Pages/Header";
import { mainNavigationStyles as styles } from "@insite/content-library/Widgets/Header/MainNavigation";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, fontFamilyHeading, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.container = {
    ...styles.container,
    css: css`
        ${styles.container?.css}
        padding: 0 16px 0 0;
    `,
};

styles.mobileSearchButton = {
    ...styles.mobileSearchButton,
    mergeCss: true,
    color: colorStrings.primaryMain,
    size: 50,
};

styles.mobileSearchModal = {
    ...styles.mobileSearchModal,
    cssOverrides: {
        modalBody: css`
            .popover {
                top: 81px !important;
            }
        `,
    },
};

styles.itemWrapper = {
    ...styles.itemWrapper,
    css: css`
        ${styles.itemWrapper?.css}
        ul {
            width: auto;

            ul {
                left: 100% !important;
            }
        }
    `,
};

styles.menuItemTypography = {
    ...styles.menuItemTypography,
    fontFamily: fontFamilyHeading,
    size: "18px",
    lineHeight: "24px",
    weight: 700,
    transform: "none",
    css: css`
        font-family: ${fontFamilyHeading};
        font-weight: 700;
    `,
    mergeCss: true,
};

styles.cascadingMenu = {
    ...styles.cascadingMenu,
    menuItemTypographyProps: {
        ...styles.cascadingMenu?.menuItemTypographyProps,
        size: "18px",
        fontFamily: fontFamilyHeading,
        lineHeight: "24px",
        weight: 700,
        transform: "none",
        css: css`
            ${styles.cascadingMenu?.menuItemTypographyProps?.css}
            color: ${getColor(colorStrings.commonGlobalWhite)};
            white-space: nowrap;
            margin-right: 16px;
        `,
    },
};

customHeaderStyles.container = {
    ...customHeaderStyles.container,
    css: css`
        ${customHeaderStyles.container?.css}
        > div:last-child {
            ${mediaQueriesBP.maxMD} {
                width: fit-content;
                padding-inline-end: 12px;
            }
        }
    `,
};

styles.compactFlyoutMenu = {
    ...styles.compactFlyoutMenu,
    css: css`
        ${styles.compactFlyoutMenu?.css}
        height: 100%;
        justify-content: center;
        align-items: center;
        padding-top: 3px;
        display: flex;
        button {
            height: 100%;
            align-items: center;
            max-height: 60px;
            outline: none;
            border: none;

            &:hover,
            &:focus,
            &:active {
                background-color: transparent;
                outline: none;
                border: none;
            }
        }
    `,
};

styles.megaMenu = {
    ...styles.megaMenu,
    contentBodyProps: {
        css: css`
            ${styles.megaMenu?.contentBodyProps?.css}
            background: ${getColor(colorStrings.primaryMain)};
            opacity: 0.85;
        `,
    },
};

styles.megaMenuGridContainer = {
    ...styles.megaMenuGridContainer,
    css: css`
        ${styles.megaMenuGridContainer?.css}
        padding-inline: 10px;
    `,
};

styles.megaMenuHeading = {
    ...styles.megaMenuHeading,
    typographyProps: {
        ...styles.megaMenuHeading?.typographyProps,
        color: colorStrings.commonGlobalWhite,
        size: "18px",
        weight: "bold",
        fontFamily: fontFamilyHeading,
        css: css`
            &&& {
                color: ${getColor(colorStrings.commonGlobalWhite)} !important;
            }

            &&&:hover {
                color: ${getColor(colorStrings.commonGlobalWhite)} !important;
            }
        `,
        mergeCss: true,
    },
    hoverStyle: {
        color: colorStrings.commonGlobalWhite,
    },
};

styles.megaMenuLink = {
    ...styles.megaMenuLink,
    typographyProps: {
        ...styles.megaMenuLink?.typographyProps,
        fontFamily: fontFamilyHeading,
        weight: 400,
        color: colorStrings.commonGlobalWhite,
        size: "16px",
        css: css`
            &&& {
                color: ${getColor(colorStrings.commonGlobalWhite)} !important;
            }

            &&&:hover {
                color: ${getColor(colorStrings.commonGlobalWhite)} !important;
                text-decoration: underline;
            }
        `,
    },
    mergeCss: true,
};
